export const SURVEY_LABEL = "Date";
export const COMPARE_TO_LABEL = "Compare to";
